import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { UnderageForm } from 'cancellations/view-models/cancellation-underage';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';

interface UnderageFormProps {
  values?: UnderageForm;
  errors: FormikErrors<UnderageForm> | undefined;
  touched: FormikTouched<UnderageForm> | undefined;
  handleFormFieldChange: (key: keyof UnderageForm, value: UnderageForm[keyof UnderageForm]) => void;
  disabled?: boolean;
}

const UnderageFormComponent = ({
  errors,
  touched,
  values,
  handleFormFieldChange,
}: UnderageFormProps): React.ReactElement => {
  return (
    <Grid container spacing={1}>
      <Grid item container xs={12} spacing={1}>
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data cancellazione *"
            aria-label="Data cancellazione"
            value={values?.date || null}
            onChange={(date) => handleFormFieldChange('date', date)}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="cancellationDate"
                fullWidth
                error={touched?.date && Boolean(errors?.date)}
                helperText={errors?.date}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={1}>
        <Grid item xs={12} md={6}>
          <PmiTextField
            aria-label="Motivo cancellazione"
            label="Motivo cancellazione *"
            id="reason"
            name="reason"
            fullWidth
            rows={5}
            multiline
            value={values?.reason || ''}
            onChange={(ev) => handleFormFieldChange('reason', ev.target.value)}
            error={touched?.reason && Boolean(errors?.reason)}
            helperText={errors?.reason}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

UnderageFormComponent.displayName = 'Underage accordion component';

const UnderageFormComponentMemo = memo(UnderageFormComponent);

export default UnderageFormComponentMemo;
